import React from 'react';
import { BooleanField, DateField, Show, SimpleShowLayout, TextField, NumberField, FunctionField } from 'react-admin';
import { formatNumber } from '../../helpers/number-helper';

export default props => (
    <Show
        {...props}
    >
        <SimpleShowLayout>
            <TextField source="id" label="ID" />
            <TextField source="PNRNumber" label="PNR Number" />
            <DateField source="BookingDate" label="Booking Date" />
            <DateField source="CheckIn" label="Check-In" />
            <DateField source="CheckOut" label="Check-Out" />
            <TextField source="RoomType" label="Room Type" />
            <TextField source="NumberRoom" label="Number of Room" />
            <TextField source="Night" />
            <TextField source="NTA" />
            <TextField source="PowersuiteID" />
            <BooleanField source="InPS" label="In Powersuite" />
            <TextField source="AgentID" label="Agent ID" />
            <TextField source="AgentCurrency" label="Agent Currency" />
            <TextField source="SellCurr" label="Selling Currency" />
            <NumberField source="AgentSelling" label="Agent Selling" />
            <NumberField source="TTV" label="TTV" />
            <TextField source="MemberID" label="Member ID" />
            <TextField source="UserID" label="User ID" />
            <BooleanField source="Processed" />
            <BooleanField source="HasUser" label="Has User" />
            <BooleanField source="HasPoints" label="Has Points" />
            <FunctionField source="Point" label="Points" render={record => formatNumber(record.Points)} sortable={false} style={{ textAlign: 'right' }} />
            <TextField source="HotelCode" label="Hotel Code" />
            <TextField source="HotelName" label="Hotel Name" />
            <TextField source="Country" label="Hotel Country" />
            <TextField source="City" label="Hotel City" />
            <TextField source="Title" />
            <TextField source="FirstName" label="First Name" />
            <TextField source="LastName" label="Last Name" />
            
            <TextField source="VoucherNo" label="Voucher No." />
            <TextField source="IssuingDate" label="Issuing Date" />
            <TextField source="Source" />
            <TextField source="SourceReference" label="Source Reference" />
            <TextField source="ReservationCode" label="Reservation Code" />
            <DateField source="UTCCreated" label="Created Date" showTime />
            <TextField source="CreatedBy" label="Created By" />
            <DateField source="UTCModified" label="Modified Date" showTime />
            <TextField source="ModifiedBy" label="Modified By" />
        </SimpleShowLayout>
    </Show>
)